<template>
  <v-dialog v-model="isShow" width="950" @click:outside="close">
    <v-card>
      <v-card-title style="text-align: left">
        <span style="font-size: 20px; font-weight: bold">CHỌN BUỔI HỌC</span>
        <v-icon @click="close">mdi-close</v-icon>
      </v-card-title>
      <v-card-text>
        <div style="color: #FF0000; margin-bottom: 6px" class="d-flex align-center">
          <v-icon color="#FF0000">mdi-alert</v-icon>
          Lưu ý: Không được xếp HS vào lớp đúng buổi kiểm tra hoặc buổi liền trước đó !!!
        </div>
        <div style="border: 1px solid #E2E2E2; border-radius: 4px">
          <v-simple-table class="class-schedule-select-table">
            <template v-slot:default>
              <thead>
                <tr>
                  <th>Lịch học</th>
                  <th>Giáo viên</th>
                  <th style="min-width: 150px; max-width: 150px">Chương trình</th>
                  <th style="min-width: 100px; max-width: 100px">Trình độ</th>
                  <th>Bài học</th>
                  <th style="min-width: 100px; max-width: 100px">Thao tác</th>
                </tr>
              </thead>
              <tbody v-if="data && data.length > 0">
                <tr v-for="(item, index) in data" :key="'item-class-schedule-' + index" :class="item.titleExam ? 'disable-row' : ''">
                  <td>
                    <div class="word-break-teacher-care-row">
                    <span style="">
                      {{
                        item.lessonStartTime
                          ? item.lessonStartTime +
                          " - " +
                          item.lessonEndTime +
                          " " +
                          formatDateVN(item.day)
                          : ""
                      }}
                    </span>
                    </div>
                  </td>
                  <td>
                    {{item.teacherName}}
                  </td>
                  <td>
                    <span v-if="!dataConfirm.currentProgramId"> <i style="opacity: 0.6;">(Chưa có KCT)</i></span>
                    <span v-else>{{item.curriculumName}}</span>
                  </td>
                  <td>
                    <div class="word-break-teacher-care-row">
                      <span v-if="!dataConfirm.currentProgramId"> <i style="opacity: 0.6;">(Chưa có KCT)</i></span>
                      <span v-else>{{ item.level }}</span>
                    </div>
                  </td>
                  <td>
                    <span v-if="!dataConfirm.currentProgramId"> <i style="opacity: 0.6;">(Chưa có KCT)</i></span>
                    <span><b v-if="item.titleExam" style="color: red">[{{item.titleExam}}] </b> {{item.lessonTitle}}</span>
                  </td>
                  <td class="text-center">
                    <v-tooltip top>
                      <template v-slot:activator="{attrs, on}">
                        <v-btn @click="selectSchedule(item)" icon v-bind="attrs" v-on="on" :disabled="item.titleExam ? true : false">
                          <v-icon style="cursor: pointer" >mdi-arrow-right</v-icon>
                        </v-btn>
                      </template>
                      <div>Chọn buổi học</div>
                    </v-tooltip>
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="99" style="color: red;">
                    Không có dữ liệu
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
      </v-card-text>
    </v-card>
    <template v-if="isShowConfirmArrangeClass">
      <confirm-arrange-class-popup
        :isShow="isShowConfirmArrangeClass"
        :arrangeClassInfo="selectedSchedule"
        :studentCareInfo="studentCareInfo"
        :dataConfirm="dataConfirm"
        @finish-create-class="finishCreateClass"
        @close="isShowConfirmArrangeClass = false"
      />
    </template>
  </v-dialog>
</template>

<script>
import ConfirmArrangeClassPopup from '@/components/arrange_class/ConfirmArrangeClassPopup.vue';
import moment from 'moment';

export default {
  name: 'PopupSelectClassSchedule',
  components: { ConfirmArrangeClassPopup },
  data() {
    return {
      teacherName: '',
      isShowConfirmArrangeClass: false,
      selectedSchedule: {},
    };
  },
  props: {
    studentCareInfo: {
      type: Object,
      required: true,
    },
    dataConfirm: {
      type: Object,
      required: true,
    },
    isShow: {
      type: Boolean,
      required: true,
    },
    data: {
      type: Array,
      required: true,
    },
  },
  methods: {
    finishCreateClass() {
      this.$emit('finish-create-class');
      this.close();
    },
    selectSchedule(item) {
      this.isShowConfirmArrangeClass = true;
      this.selectedSchedule = _.cloneDeep(item);
    },
    close() {
      this.$emit('close');
    },
    formatDateVN(date) {
      if (date) {
        return moment(date)
          .format('DD/MM/YYYY');
      }
      return '';
    },
  },
};
</script>

<style scoped lang="scss">
.class-schedule-select-table {
  thead{
    tr {
      th {
        font-weight: bold;
        font-size: 14px !important;
      }
    }
  }
  tbody {
    tr {
      &.disable-row {
        td {
          color: #B0B0B0;
        }
      }
    }
  }
}
</style>
